<template>
  <vs-row class="bg-white shadow py-5 px-3 mb-4">
    <vs-col vs-lg="11">
      <vs-row>
        <vs-col
            vs-lg="2"
            class="text-center"
        >
          <b>#</b>
        </vs-col>
        <vs-col vs-lg="2">
          <b>Estado</b>
        </vs-col>
        <vs-col vs-lg="8">
          <vs-row>
            <vs-col vs-lg="3">
              <b>Enviado por</b>
            </vs-col>
            <vs-col vs-lg="3">
              <b class="ml-6">Creado por</b>
            </vs-col>
            <vs-col
                vs-lg="3"
                v-if="onPendingFiles"
            >
              <b>Derivado por</b>
            </vs-col>
            <vs-col
                vs-lg="6"
                v-if="!onPendingFiles"
            >
              <b>Resumen</b>
            </vs-col>
            <vs-col
                vs-lg="3"
                vs-md="3"
                vs-sm="3"
                vs-xs="12"
                v-if="onPendingFiles"
            >
              <b>Resumen</b>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
    </vs-col>
    <vs-col
        vs-lg="1"
        vs-sm="4"
        vs-xs="12"
        class="text-center"
    >
      <b v-if="!exportable">...</b>
      <font-awesome-icon
          v-if="exportable"
          :icon="['fas', 'download']"
          class="action-icon"
          style="cursor: pointer"
          v-b-tooltip="'Descargar Listado'"
          @click="$emit('export-list', true)"
          data-cy="download-list"
      />
    </vs-col>
  </vs-row>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faDownload
} from '@fortawesome/free-solid-svg-icons';

import EDIcons from '@/febos/global/documentManagement/mixins/EDIcons';

library.add(
  faDownload
);
export default {
  props: [
    'onPendingFiles', 'exportable'
  ],
  mixins: [EDIcons],
  computed: {
    isConvention() {
      return this.company.iut === '60100003-2';
    }
  }
};

</script>
